export default __webpack_public_path__ + "static/media/Walker's Boots of the Four Winds.508967bd.jpg";